module.exports = __webpack_public_path__ + "img/vinyl.ecf5201b.svg";